import { Injectable } from '@angular/core';
import { FeaturesEnum } from '@cpak/enums';
import { map, Observable } from 'rxjs';
import { StartService } from './start/start.service';
@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  constructor(private startService: StartService) {}
  public isFeatureEnabled(featureName: FeaturesEnum): Observable<boolean> {
    return this.startService.getStartResponse().pipe(
      map(start => {
        const config = start?.data?.config;
        if (!config) return false;
        const feature = config.features.find(feature => feature.name === featureName);
        return !!feature?.environments.includes(config.environment);
      })
    );
  }
}
